var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-app', {
    staticClass: "content",
    style: _vm.themeStyle
  }, [_c('console-app-bar', {
    attrs: {
      "title": _vm.title,
      "color": "app-bar"
    },
    model: {
      value: _vm.drawer,
      callback: function ($$v) {
        _vm.drawer = $$v;
      },
      expression: "drawer"
    }
  }), _c('console-drawer', {
    model: {
      value: _vm.drawer,
      callback: function ($$v) {
        _vm.drawer = $$v;
      },
      expression: "drawer"
    }
  }), _c('v-content', [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_vm._t("default")], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }